import {
  AvailableFeatureFlags,
  FeatureFlagMap,
} from '../../models/feature-flags';
import { createStore, filterNil, select, withProps } from '@ngneat/elf';
import { shareReplay } from 'rxjs';

interface FeatureFlagsProps {
  featureFlagsInitialized: boolean | null;
  featureFlags: FeatureFlagMap;
}

const featureFlagsStore = createStore(
  { name: 'feature-flags' },
  withProps<FeatureFlagsProps>({
    featureFlagsInitialized: null,
    featureFlags: new Map(),
  })
);

export const featureFlagsInitialized$ = featureFlagsStore.pipe(
  select(({ featureFlagsInitialized }) => featureFlagsInitialized),
  filterNil(),
  shareReplay({ bufferSize: 1, refCount: true })
);

export const featureFlags$ = featureFlagsStore.pipe(
  select(({ featureFlags }) => featureFlags),
  shareReplay({ bufferSize: 1, refCount: true })
);

export function updateFeatureFlagsInitialized(
  featureFlagsInitialized: boolean
) {
  featureFlagsStore.update((state) => ({
    ...state,
    featureFlagsInitialized,
  }));
}

export function updateFeatureFlags(featureFlags: FeatureFlagMap) {
  featureFlagsStore.update((state) => ({
    ...state,
    featureFlags,
  }));
}

export const resetFeatureFlagsStore = () => {
  featureFlagsStore.update(() => ({
    featureFlagsInitialized: null,
    featureFlags: new Map(),
  }));
};

export const isFeatureEnabled = (flag: AvailableFeatureFlags) =>
  featureFlagsStore.getValue().featureFlags.get(flag)?.enabled ?? false;
